import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../api/axiosConfig";
import signOut from "../../../functions/userIdentity/signOut";

// Action Types
export const CALENDAR_TIMETABLE_EVENTS_SUCCESS = "CALENDAR_TIMETABLE_EVENTS_SUCCESS";
export const CALENDAR_TIMETABLE_EVENTS_ERROR = "CALENDAR_TIMETABLE_EVENTS_ERROR";

// Thunk Action Creator
export const getTimetableFileEventsAction = createAsyncThunk(
    "api/Calendar/getTimetableEvents",
    async (json, { dispatch }) => {

        try {
            let providerNum;
            if (json.type === 'microsoft') {
                providerNum = 1;
            } else {
                providerNum = 0;
            }

            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

            const response = await axios.post(
                `${import.meta.env.VITE_PUBLIC_DOMAIN}Calendar/getEvents/${json.month}/${json.year}`,
                {
                    AccessToken: json.accessToken,
                    CalendarId: json.calendarId,
                    Type: providerNum,
                    TimeZone: timeZone
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )

            if (response.status === 200) {
                dispatch({
                    type: CALENDAR_TIMETABLE_EVENTS_SUCCESS,
                    payload: response.data,
                });
            }
        }
        catch (error) {
            dispatch({ type: CALENDAR_TIMETABLE_EVENTS_ERROR, payload: error });
        }
    }
);
